module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@2.3.8@readable-stream/passthrough.js
// module id = 770
// module chunks = 0